import { includes, replace, startCase, slice } from 'lodash';
import unorm from 'unorm';

function phoneFormat(value, format) {
  // The phone field on add new patients under waitlists accepts blank phone numbers, so this is a work around for it
  if (value) {
    // default, withoutDash, onlyDash
    const phoneValue = value.match(value.length === 10 ? /(\d{3})(\d{3})(\d{4})/ : /(\d{3})(\d{3})(\d{3})/);
    if (phoneValue) {
      if (format === 'withoutDash') {
        return `(${phoneValue[1]})${phoneValue[2]}${phoneValue[3]}`;
      }
      if (format === 'onlyDash') {
        return `${phoneValue[1]}-${phoneValue[2]}-${phoneValue[3]}`;
      }
      return `(${phoneValue[1]})${phoneValue[2]}-${phoneValue[3]}`;
    }
  }
  return '';
}

export function phoneMaskUS(value, format) {
  const onlyNums = value.replace('+1 ', '').replace(/\D/g, '');

  if (onlyNums) {
    return phoneFormat(onlyNums, format);
  }
}

export function phoneOnlyNumbers(value) {
  if (!value) {
    return value;
  }

  return value
    .replace('+1 ', '')
    .replace('-', '')
    .replace(/[^\d]/g, '');
}

export function highlightText(text, typedWord) {
  if (text) {
    const wordLowerCase = startCase(typedWord.toLowerCase());
    const normalizedWord = unorm.nfd(wordLowerCase);
    const updatedWord = normalizedWord.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '');

    const pattern = new RegExp(`(${updatedWord})`, 'gi');
    const newText = text.replace(pattern, `<strong>${updatedWord}</strong>`);
    return newText;
  }
}

export function highlightDOB(text, typedWord) {
  if (text && typedWord.length > 0) {
    if (includes(text, typedWord)) {
      const newText = replace(text, typedWord, typedWord.bold());
      return newText;
    }
  }
  return text;
}

export function highlightNumbers(text, typedWord) {
  if (text && typedWord.length > 0) {
    let cleanTypedWord1;
    let cleanTypedWord2;
    let cleanTypedWord3;
    let bold1;
    let bold2;
    let bold3;
    const cleanTypedWord = typedWord.replace(/[^A-Z0-9]+/gi, '');
    const cleanText = text.replace(/[()-]/g, '');
    const cleanText1 = slice(cleanText, 0, 3).join('');
    const cleanText2 = slice(cleanText, 3, 6).join('');
    const cleanText3 = slice(cleanText, 6, 10).join('');

    if (cleanTypedWord.length > 0) {
      cleanTypedWord1 = slice(cleanTypedWord, 0, 3).join('');
    }
    if (cleanTypedWord.length > 3) {
      cleanTypedWord2 = slice(cleanTypedWord, 3, 6).join('');
    }
    if (cleanTypedWord.length > 6) {
      cleanTypedWord3 = slice(cleanTypedWord, 6, 10).join('');
    }
    if (includes(cleanText1, cleanTypedWord1)) {
      bold1 = replace(cleanText1, cleanTypedWord1, cleanTypedWord1.bold());
    } else {
      bold1 = cleanText1;
    }
    if (includes(cleanText2, cleanTypedWord2)) {
      bold2 = replace(cleanText2, cleanTypedWord2, cleanTypedWord2.bold());
    } else {
      bold2 = cleanText2;
    }
    if (includes(cleanText3, cleanTypedWord3)) {
      bold3 = replace(cleanText3, cleanTypedWord3, cleanTypedWord3.bold());
    } else {
      bold3 = cleanText3;
    }
    return `(${bold1})${bold2}-${bold3}`;
  }
  return text;
}
